"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sync = exports.scanAccounts = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const api_1 = require("./api");
const jsHelpers_1 = require("../../bridge/jsHelpers");
const operation_1 = require("../../operation");
const account_1 = require("../../account");
const js_1 = require("./bridge/js");
const txToOperation = (accountId, address) => ({ meta: { delivered_amount }, tx: { DestinationTag, Fee, hash, inLedger, date, Account, Destination, Sequence }, }) => {
    const type = Account === address ? "OUT" : "IN";
    let value = delivered_amount && typeof delivered_amount === "string"
        ? new bignumber_js_1.default(delivered_amount)
        : new bignumber_js_1.default(0);
    const feeValue = new bignumber_js_1.default(Fee);
    if (type === "OUT") {
        if (!Number.isNaN(feeValue)) {
            value = value.plus(feeValue);
        }
    }
    // https://xrpl.org/basic-data-types.html#specifying-time
    const toEpochDate = (946684800 + date) * 1000;
    const op = {
        id: (0, operation_1.encodeOperationId)(accountId, hash, type),
        hash: hash,
        accountId: accountId,
        type,
        value,
        fee: feeValue,
        blockHash: null,
        blockHeight: inLedger,
        senders: [Account],
        recipients: [Destination],
        date: new Date(toEpochDate),
        transactionSequenceNumber: Sequence,
        extra: {},
    };
    if (DestinationTag) {
        op.extra.tag = DestinationTag;
    }
    return op;
};
const filterOperations = (transactions, accountId, address) => {
    return transactions
        .filter((tx) => tx.tx.TransactionType === "Payment" && typeof tx.meta.delivered_amount === "string")
        .map(txToOperation(accountId, address))
        .filter(Boolean);
};
const getAccountShape = (info) => __awaiter(void 0, void 0, void 0, function* () {
    const { address, initialAccount, currency, derivationMode } = info;
    const accountId = (0, account_1.encodeAccountId)({
        type: "js",
        version: "2",
        currencyId: currency.id,
        xpubOrAddress: address,
        derivationMode,
    });
    const accountInfo = yield (0, api_1.getAccountInfo)(address);
    if (!accountInfo || accountInfo.error === js_1.NEW_ACCOUNT_ERROR_MESSAGE) {
        return {
            id: accountId,
            xpub: address,
            blockHeight: 0,
            balance: new bignumber_js_1.default(0),
            spendableBalance: new bignumber_js_1.default(0),
            operations: [],
            operationsCount: 0,
        };
    }
    const serverInfo = yield (0, api_1.getServerInfo)();
    const oldOperations = (initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.operations) || [];
    const startAt = oldOperations.length ? (oldOperations[0].blockHeight || 0) + 1 : 0;
    const ledgers = serverInfo.info.complete_ledgers.split("-");
    const minLedgerVersion = Number(ledgers[0]);
    const maxLedgerVersion = Number(ledgers[1]);
    const balance = new bignumber_js_1.default(accountInfo.account_data.Balance);
    const newTransactions = (yield (0, api_1.getTransactions)(address, {
        ledger_index_min: Math.max(startAt, // if there is no ops, it might be after a clear and we prefer to pull from the oldest possible history
        minLedgerVersion),
        ledger_index_max: maxLedgerVersion,
    })) || [];
    const newOperations = filterOperations(newTransactions, accountId, address);
    const operations = (0, jsHelpers_1.mergeOps)(oldOperations, newOperations);
    const shape = {
        id: accountId,
        xpub: address,
        blockHeight: maxLedgerVersion,
        balance,
        spendableBalance: balance,
        operations,
        operationsCount: operations.length,
    };
    return shape;
});
exports.scanAccounts = (0, jsHelpers_1.makeScanAccounts)({ getAccountShape });
exports.sync = (0, jsHelpers_1.makeSync)({ getAccountShape });
//# sourceMappingURL=js-synchronization.js.map